<template>
  <section class="min-h-[504px]">
    <div class="text-center">
      <NoNews class="m-auto w-[320px] h-[320px] md:w-[400px] md:h-[400px]" />
      <h2
        class="m-auto mt-2 text-black-600 text-2xl font-bold text-center !w-[fit-content]"
      >
        {{ computedTitle }}
      </h2>
      <h1
        class="m-auto mt-2 text-black-600 text-base text-center !w-[fit-content] mb-4"
      >
        {{ computedDescription }}
      </h1>
      <!-- <Btn> {{ $t("common.clear_filter") }} </Btn> -->
    </div>
  </section>
</template>
<script setup>
import NoNews from "@/assets/svg/no-news.svg?component";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";

const props = defineProps({
  title: String,
  description: String,
});

const { t } = useTranslation();

const computedTitle = computed(() => props.title || t("common.sorry_text"));
const computedDescription = computed(
  () => props.description || t("common.no_news")
);
</script>
